import { create } from 'zustand'
import type { TourBooking } from '../types/tours.types'

/**
 * Contexto de checkout de Tours (F2).
 *
 * La reserva (`tours-reserve`) devuelve un `TourBooking`; ese resultado tiene que
 * sobrevivir la navegación a la pantalla de pago, así que vive acá y no en
 * params de ruta. `reset()` es obligatorio por la invariante de stores del repo.
 */
export interface ToursCheckoutContext {
  booking: TourBooking
  title: string
  originLabel: string
  destinationLabel: string
  startsAt: string
  luggageLabels: string[]
  coverImageUrl?: string | null
  /** Private itineraries have no editorial destination image. Keep their route
   * identity explicit through checkout instead of borrowing a catalog cover. */
  customTour?: {
    vehicleLabel: string
    stopCount: number
  }
}

interface ToursCheckoutState {
  context: ToursCheckoutContext | null
  setContext: (context: ToursCheckoutContext) => void
  reset: () => void
}

export const useToursCheckoutStore = create<ToursCheckoutState>((set) => ({
  context: null,
  setContext: (context) => set({ context }),
  reset: () => set({ context: null }),
}))
